<template>
  <button
    :class="[$style.button, chosen && $style.chosen,
             small && $style.small,
             windowsWidth <=700 && $style.mobileButton]"
  >
    <slot />
  </button>
</template>

<style lang="scss" module>
.button {
  font-size: 1.8rem;
  font-weight: bold;
  width: 45%;
  min-height: 48px;
  padding: 14px 30px;
  cursor: pointer;
  letter-spacing: 1.1px;
  color: #fff;
  border: solid 1px #fff8fb;
  border-radius: 6px;
  outline: none;
  background-color: rgba(197, 197, 197, 0.629359);
  transition: background-color 0.2s;

  &.small {
    min-height: 30px;
    padding: 12px 25px;
    font-size: 14px;
  }

  &.chosen {
    background-color: #e73273;
  }

  &.mobileButton {
    padding: 12px 20px;
    font-size: 1.4rem;
  }

  &:active:enabled {
    background-color: #e73273;
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    chosen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      windowsWidth: state => state.ui.windowsWidth,
    }),
  },
};
</script>
